import { produce } from 'immer'

export const ROLE_ADMIN = 'ROLE_PHILIPS_ADMIN'
export const ROLE_LUMIFY_ADMIN = 'ROLE_LUMIFY_ADMIN'
export const ROLE_SMARTSWEEP_ADMIN = 'ROLE_SMARTSWEEP_ADMIN'
export const ROLE_LUMIFY_SALES_MANAGER = 'ROLE_LUMIFY_SALES_MANAGER'
export const ROLE_SMARTSWEEP_SALES_MANAGER = 'ROLE_SMARTSWEEP_SALES_MANAGER'
export const ROLE_LUMIFY_SALES = 'ROLE_LUMIFY_SALES'
export const ROLE_SMARTSWEEP_SALES = 'ROLE_SMARTSWEEP_SALES'
export const ROLE_USER = 'ROLE_PHILIPS_USER'
export const ROLE_NONE = 'ROLE_NONE'

export const ROLE_NAME_LOOKUP = {
  [ROLE_ADMIN]: 'Admin',
  [ROLE_LUMIFY_ADMIN]: 'Lumify Admin',
  [ROLE_SMARTSWEEP_ADMIN]: 'SmartSweep Admin',
  [ROLE_LUMIFY_SALES_MANAGER]: 'Lumify Sales Manager',
  [ROLE_SMARTSWEEP_SALES_MANAGER]: 'SmartSweep Sales Manager',
  [ROLE_LUMIFY_SALES]: 'Lumify Sales',
  [ROLE_SMARTSWEEP_SALES]: 'SmartSweep Sales',
  [ROLE_USER]: 'View Only'
}

export const getRoleById = id => {
  switch (id) {
    case 1:
      return ROLE_ADMIN
    case 2:
      return ROLE_LUMIFY_SALES_MANAGER
    case 3:
      return ROLE_LUMIFY_SALES
    case 4:
      return ROLE_USER
    case 5:
      return ROLE_LUMIFY_ADMIN
    case 6:
      return ROLE_SMARTSWEEP_ADMIN
    case 7:
      return ROLE_SMARTSWEEP_SALES_MANAGER
    case 8:
      return ROLE_SMARTSWEEP_SALES
    default:
      return ROLE_NONE
  }
}

export default produce({}, draft => {
  draft.ROLE_ADMIN = ROLE_ADMIN
  draft.ROLE_LUMIFY_ADMIN = ROLE_LUMIFY_ADMIN
  draft.ROLE_SMARTSWEEP_ADMIN = ROLE_SMARTSWEEP_ADMIN
  draft.ROLE_LUMIFY_SALES_MANAGER = ROLE_LUMIFY_SALES_MANAGER
  draft.ROLE_LUMIFY_SALES = ROLE_LUMIFY_SALES
  draft.ROLE_SMARTSWEEP_SALES_MANAGER = ROLE_SMARTSWEEP_SALES_MANAGER
  draft.ROLE_SMARTSWEEP_SALES = ROLE_SMARTSWEEP_SALES
  draft.ROLE_USER = ROLE_USER
  draft.ROLE_NONE = ROLE_NONE
})
